import {sprintf} from "sprintf-js";

const MIN_SCORE = 3;
const PASS_MIN_LEN = 10;
const PASS_LEN_MSG = sprintf("Must be at least %s characters in length", PASS_MIN_LEN);

const ZxcvbnTest = async (value, context) => {
    if (!!value) {
        const result = await import("zxcvbn-typescript").then(module => {
            const {zxcvbn} = module;
            return zxcvbn(value);
        });
        if (result.score < MIN_SCORE) {
            return Promise.resolve(context.createError({message: result.feedback.suggestions[0]}));
        }
        return Promise.resolve(true);
    }
    return Promise.resolve(context.createError({message: "Password somehow undef"}));
}

export default ZxcvbnTest;
export {PASS_MIN_LEN, PASS_LEN_MSG};